// Portal V2
import LoggedInView from "components/PortalV2/LoggedInView";
import LoggedOutView from "components/PortalV2/LoggedOutView";
import PortalSwitch from "components/PortalV2/PortalSwitch";
import PortalLogin from "components/PortalV2/Login";
import PortalLoginCallback from "components/PortalV2/Login/Callback";

import PortalWrapper from "Portal/PortalWrapper/View";
import ManagePortals from "Portal/Manage/View";
import PortalSidebar from "Portal/PortalSidebar";
import PortalHomeRouter from "Portal/PortalHomeRouter";
import PortalDocuments from "Portal/PortalDocuments";
import PortalPage from "Portal/PortalPageWrapper/View";
import PortalSession from "Portal/PortalSession/View";
import SSOLink from "Portal/SSOLink/View";

const PortalModule = {
  LoggedInView,
  LoggedOutView,
  PortalWrapper,
  ManagePortals,
  PortalSidebar,
  PortalHomeRouter,
  PortalDocuments,
  PortalSwitch,
  PortalLogin,
  PortalLoginCallback,
  PortalPage,
  PortalSession,
  SSOLink
};

export default PortalModule;
